import { Mapper } from '../../../../common/ddd/mapper.base';
import { formatDeviationPrefix } from '../../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../../common/utils/format-duration.util';
import { formatPrice } from '../../../../common/utils/format-price';
import { AccountCallsSummaryAggregateRoot } from '../../../../core/domain/aggregates/org-metrics/account-calls-summary.aggregate-root';
import { GetAccountCallsSummaryResponseDto } from '../../../../interface/dtos/org-metrics/calls/get-account-calls-summary-response.dto';
import { AccountCallsSummaryItemAggregateRootMapper } from './account-calls-summary-item.aggregate-root.mapper';

export type IAccountCallsSummaryAggregateRootMapper = Mapper<
  AccountCallsSummaryAggregateRoot,
  GetAccountCallsSummaryResponseDto
>;

export class AccountCallsSummaryAggregateRootMapper
  implements Omit<IAccountCallsSummaryAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: AccountCallsSummaryAggregateRoot
  ): GetAccountCallsSummaryResponseDto {
    return AccountCallsSummaryAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: AccountCallsSummaryAggregateRoot
  ): GetAccountCallsSummaryResponseDto {
    return {
      totalTime: formatDuration(entity.value),
      averageTime: formatDuration(entity.average),
      totalTimeDeviation: `${formatDeviationPrefix(
        entity.deviation
      )}${formatDuration(entity.deviation)}`,
      totalCostDeviation: formatPrice(entity.costDeviation / 1000 / 60 / 60),
      averageCostDeviation: formatPrice(
        entity.averageCostDeviation / 1000 / 60 / 60
      ),
      totalCost: formatPrice(entity.cost / 1000 / 60 / 60),
      averageCost: formatPrice(
        entity.averageCost > 0 ? entity.averageCost / 1000 / 60 / 60 : 0
      ),
      averageTimeDeviation: `${formatDeviationPrefix(
        entity.averageDeviation
      )}${formatDuration(entity.averageDeviation)}`,
      appTypes: entity.data.map((appType) =>
        AccountCallsSummaryItemAggregateRootMapper.toResponse(appType)
      ),
    };
  }
}
